import React, { createContext, useRef, useLayoutEffect, useState } from 'react';
import propTypes from 'prop-types';
import { DATE_FORMAT } from '~/Redux/Constants';
import moment from '~/Providers/Moment';
import { FLAG_DRAWINGS } from '~/Redux/Modules/FeatureFlags';
import FeatureFlagView from '../FeatureFlagView';
import { ALIGN_CENTER, ALIGN_TOP_CENTER, DrawingDisplay } from './DrawingDisplay';
import { boundsForPoints, closestBox } from './DrawingUtils';

export const DrawingContext = createContext({});

export const DrawingProvider = ({
  startDate,
  endDate,
  views,
  listId,
  listRef,
  alignment,
  children,
}) => {
  const rectsRef = useRef({});
  const [rerenderNumber, setRerenderNumber] = useState(0);
  const rerenderInterval = useRef();

  const value = {
    rerenderNumber,
    setRerenderNumber: number => {
      console.log('Set rerender Number:', number);
      if (rerenderInterval.current) {
        clearTimeout(rerenderInterval.current);
      }
      rerenderInterval.current = setTimeout(() => setRerenderNumber(number), 1000);
    },
    drawingRectForDrawing: listOfPoints => {
      const drawingDimensions = boundsForPoints(listOfPoints);
      const box = closestBox(
        { centX: drawingDimensions.centerX, centY: drawingDimensions.centerY },
        rectsRef.current
      );

      const closestDate = Object.keys(rectsRef.current).find(
        date => rectsRef.current[date] === box
      );

      if (
        box.left < drawingDimensions.centerX &&
        drawingDimensions.centerX < box.right &&
        box.top < drawingDimensions.centerY &&
        drawingDimensions.centerY < box.bottom
      ) {
        return { date: closestDate, box: box };
      } else {
        return {
          date: moment(startDate)
            .startOf('month')
            .format(DATE_FORMAT),
          box: undefined,
        };
      }
    },
    registerRect: (date, rect) => {
      rectsRef.current = { ...rectsRef.current, [date]: rect };
    },
    rectForDate: date => {
      const rect = rectsRef.current[date];
      return rect;
    },
  };

  return (
    <DrawingContext.Provider value={value}>
      {children}
      <FeatureFlagView featureName={FLAG_DRAWINGS}>
        <DrawingDisplay
          startDate={startDate}
          endDate={endDate}
          views={views}
          listId={listId}
          listRef={listRef}
          alignment={alignment}
        />
      </FeatureFlagView>
    </DrawingContext.Provider>
  );
};

DrawingProvider.propTypes = {
  children: propTypes.node,
  startDate: propTypes.string,
  endDate: propTypes.string,
  views: propTypes.arrayOf(propTypes.string).isRequired,
  listId: propTypes.number,
  alignment: propTypes.oneOf([ALIGN_CENTER, ALIGN_TOP_CENTER]).isRequired,
  listRef: propTypes.shape({ current: propTypes.instanceOf(Element) }),
};

DrawingProvider.defaultProps = {
  alignment: ALIGN_CENTER,
};
